// WP-07 — D-F1 i18n scaffold (same pattern as apps/api/src/i18n): every
// user-facing string lives in a catalogue from day 1. English only; Afrikaans
// becomes a second catalogue file later, never a refactor.
export const en = {
  "app.name": "Steier",
  "app.office": "Office",

  "nav.dashboard": "Dashboard",
  "nav.jobs": "Jobs",
  "nav.calendar": "Calendar",
  "nav.invoicing": "Invoicing",
  "nav.quotes": "Quotes",
  "nav.clients": "Clients",
  "nav.foremen": "Foremen",
  "nav.catalogue": "Catalogue",
  "nav.settings": "Settings",

  "shell.skipToContent": "Skip to content",
  "shell.signOut": "Sign out",
  "shell.navLabel": "Primary",
  // WP-T-2 (UX v1.6 §3): the persistent primary action in the sidebar.
  "shell.newJob": "+ New job",
  // WP-T-2 (UX v1.6 §10.8): the Page Header overflow menu (the glyph is CSS).
  "components.actionsMenu": "Actions",

  "signIn.heading": "Sign in",
  "signIn.companyCodeLabel": "Company code",
  "signIn.companyCodeHelp":
    "Enter your company code to continue to your organization's sign-in.",
  "signIn.continue": "Continue",
  "signIn.changeCompany": "Use a different company code",
  "signIn.emailLabel": "Email",
  "signIn.passwordLabel": "Password",
  "signIn.submit": "Sign in",
  "signIn.pending": "Signing in…",

  "errors.network":
    "Cannot reach the server. Check your connection and try again.",
  "errors.unexpected":
    "Something went wrong (ref: {correlationId}). Please retry.",
  "errors.foremanNoAccess":
    "Foremen use the Steier field app — the office app is not available for the foreman role.",
  "errors.sessionExpired": "Your session has expired. Please sign in again.",

  "screens.o02.title": "Dashboard",
  "screens.o03.title": "Jobs",
  "screens.o04.title": "New Job",
  "screens.o05.title": "Job Card",
  "screens.o06.title": "Calendar",
  "screens.o07.title": "Schedule / Assign",
  "screens.o08.title": "Booking Confirmation",
  "screens.o09.title": "Ready for Invoicing",
  "screens.o10.title": "Invoice Link-back",
  "screens.o11.title": "Quotes",
  "screens.o12.title": "Clients",
  "screens.o13.title": "Foreman History",
  "screens.o14.title": "Catalogue",
  "screens.o15.title": "Organization Settings",

  // WP-11 — O-12 Clients (US 2.1)
  "clients.searchLabel": "Search clients",
  "clients.searchPlaceholder": "name or phone…",
  "clients.new": "+ New client",
  "clients.loading": "Loading clients…",
  "clients.empty": "No clients match your search.",
  "clients.jobCount": "{count} jobs",
  "clients.col.name": "Client",
  "clients.col.phone": "Phone",
  "clients.col.jobs": "Jobs",
  "clients.open": "Open {name}",
  "clients.detail.back": "All clients",
  "clients.detail.contact": "Contact",
  "clients.detail.edit": "Edit",
  "clients.detail.addresses": "Addresses ({count})",
  "clients.detail.addAddress": "+ Add address",
  "clients.detail.default": "default",
  "clients.detail.jobHistory": "Job history ({count})",
  "clients.detail.noJobs": "No jobs for this client yet.",
  "clients.detail.immutabilityNote":
    "Edits update FUTURE jobs only — past job cards keep the details they were done under.",
  "clients.form.newTitle": "New client",
  "clients.form.editTitle": "Edit client",
  "clients.form.addAddressTitle": "Add address",
  "clients.form.nameLabel": "Name",
  "clients.form.phoneLabel": "Phone",
  "clients.form.emailLabel": "Email",
  "clients.form.line1Label": "Address line",
  "clients.form.suburbLabel": "Suburb",
  "clients.form.cityLabel": "City",
  "clients.form.postalCodeLabel": "Postal code",
  "clients.form.isPrimaryLabel": "Default address",
  "clients.form.addAnotherAddress": "+ Add another address",
  "clients.form.removeAddress": "Remove address {index}",
  "clients.form.addressLegend": "Address {index}",
  "clients.form.save": "Save",
  "clients.form.saving": "Saving…",
  "clients.form.cancel": "Cancel",
  "clients.form.nameRequired": "Client name is required.",
  "clients.form.phoneInvalid":
    "Phone number format is not recognised. Use digits with an optional leading + (e.g. +27 21 555 0100).",
  "clients.form.emailInvalid": "Email address format is not valid.",
  "clients.form.line1Required": "Address line is required.",

  "placeholder.body":
    "This screen is scaffolded by WP-07 and arrives with its feature work package (Track E).",
  "notFound.title": "Page not found",
  "notFound.body": "There is nothing at this address.",

  // WP-10 — jobs vertical (O-03 / O-04 / O-05)
  "jobs.stage.NEW": "New",
  "jobs.stage.SCHEDULED": "Scheduled",
  "jobs.stage.ON_SITE": "On site",
  "jobs.stage.IN_PROGRESS": "In progress",
  "jobs.stage.COMPLETED": "Completed",
  "jobs.stage.READY_FOR_INVOICING": "Ready for invoicing",
  "jobs.stage.INVOICED": "Invoiced",
  "jobs.stage.ON_HOLD": "On hold",
  "jobs.stage.CANCELLED": "Cancelled",

  "jobs.holdRequestStatus.PENDING": "awaiting office decision",
  "jobs.holdRequestStatus.CONFIRMED": "confirmed — job placed on hold",
  "jobs.holdRequestStatus.DECLINED": "declined",

  "jobs.list.heading": "Jobs",
  "jobs.list.newJob": "+ New job",
  "jobs.list.searchLabel": "Search jobs",
  "jobs.list.searchPlaceholder": "Search: job #, client, phone…",
  "jobs.list.stageFilter": "Stage",
  "jobs.list.allStages": "All stages",
  "jobs.list.hideCancelled": "Hide cancelled",
  "jobs.list.loading": "Loading jobs…",
  "jobs.list.noResults": "No jobs match.",
  "jobs.list.noResultsHint":
    "Adjust the search or filters — cancelled jobs are hidden by default.",
  "jobs.list.colNumber": "Job #",
  "jobs.list.colClient": "Client / job",
  "jobs.list.colForeman": "Foreman",
  "jobs.list.colDate": "Date",
  "jobs.list.colStage": "Stage",
  "jobs.list.colActions": "Actions",
  // WP-30 (V4) — schedule straight from the list; the unscheduled job is the
  // whole point, since O-07 can only be reached with a `?jobId=`.
  "jobs.list.schedule": "Schedule",
  "jobs.list.reschedule": "Reschedule",
  "jobs.list.cancelledReason": "Cancelled: {reason}",
  "jobs.list.holdRequested": "⏸ hold requested",

  "jobs.new.heading": "New job",
  "jobs.new.clientLabel": "Client",
  "jobs.new.clientPlaceholder": "Type a client name or phone number…",
  "jobs.new.clientHint":
    "Pick an existing client. A new client is added under Clients first, then picked here.",
  "jobs.new.clientResults": "Matching clients",
  "jobs.new.noClientMatch": "No matching client on file.",
  "jobs.new.jobCount": "{count} job(s)",
  "jobs.new.addressLegend": "Address ({count} on file)",
  "jobs.new.descriptionLabel": "Job description",
  "jobs.new.callOutLabel": "Call-out type (optional — foreman can capture on site)",
  "jobs.new.callOutNone": "None yet",
  "jobs.new.travelLabel": "Travel applies",
  "jobs.new.travelRateLabel": "Travel rate",
  "jobs.new.duplicateTitle": "⚠ Possible duplicate — an open job for this client looks similar:",
  "jobs.new.duplicateOpened": "· opened {date}",
  "jobs.new.openExisting": "Open {number}",
  "jobs.new.thisIsNew": "This is a new job",
  "jobs.new.cancel": "Cancel",
  "jobs.new.save": "Save job",
  "jobs.new.saving": "Saving…",

  "jobs.card.loading": "Loading job…",
  "jobs.card.notFound": "This job could not be loaded.",
  "jobs.card.backToJobs": "← Jobs",
  "jobs.card.createdBy": "Created {date} by {by}",
  "jobs.card.actionsLabel": "Job actions",
  "jobs.card.putOnHold": "Put on hold…",
  "jobs.card.reopen": "Reopen job…",
  "jobs.card.cancel": "Cancel job…",
  "jobs.card.neverDeleted": "Reason required — jobs are never deleted.",
  "jobs.card.onHoldBanner": "⏸ On hold — {reason}",
  "jobs.card.cancelledBanner": "✕ Cancelled — {reason}",
  "jobs.card.holdRequestBanner":
    "⏸ On-Hold requested by {by} — “{reason}” ({at}). Only the office places the job on hold.",
  "jobs.card.confirmHold": "Confirm on hold",
  "jobs.card.decline": "Decline…",
  "jobs.card.declineNoteLabel": "Note to the foreman (optional)",
  "jobs.card.declineConfirm": "Decline request",
  "jobs.card.declineAbort": "Back",
  "jobs.card.holdRequestedTitle": "The foreman has requested On Hold — confirm or decline on the job card.",
  "jobs.card.reasonHeading.hold": "Put this job on hold",
  "jobs.card.reasonHeading.reopen": "Reopen this job",
  "jobs.card.reasonHeading.cancel": "Cancel this job",
  "jobs.card.reasonRequired":
    "A reason is required and is logged on the permanent record — jobs are never deleted.",
  "jobs.card.reasonLabel": "Reason",
  "jobs.card.reasonSubmit.hold": "Put on hold",
  "jobs.card.reasonSubmit.reopen": "Reopen",
  "jobs.card.reasonSubmit.cancel": "Cancel job",
  "jobs.card.reasonCancel": "Back",
  "jobs.card.scheduleHeading": "Schedule",
  // WP-30 (V4) — the route to O-07. The old copy promised a work package that
  // had already shipped; what was missing was the link, not the feature.
  "jobs.card.notScheduled": "Not scheduled yet.",
  "jobs.card.scheduleJob": "Schedule this job",
  "jobs.card.reschedule": "Reschedule…",
  "jobs.card.attendanceHeading": "Time on site",
  "jobs.card.noCheckEvents": "No check-in yet.",
  "jobs.card.onSiteTotal": "On site: {minutes} min (materials trips excluded)",
  "jobs.card.checkedIn": "Checked in",
  "jobs.card.checkedOut.LEAVING_SITE": "Checked out (leaving site)",
  "jobs.card.checkedOut.FETCHING_MATERIALS": "Checked out (fetching materials)",
  "jobs.card.gpsMissing": "no GPS (flagged)",
  "jobs.card.farFromAddress": "far from address (flagged)",
  // WP-31 (US 4.5) — the sign-off section. It was a named placeholder since
  // WP-10 because the story had no table, endpoint or screen anywhere in the
  // product (audit P2-09): there was literally nothing to display.
  "jobs.card.signOffHeading": "Sign-off",
  "jobs.card.noSignature": "No sign-off recorded for this job yet.",
  "jobs.card.signedByClient": "Signed by {name} (the client)",
  // The BRS edge case, on the surface the BRS names: "the job card shows
  // exactly who signed".
  "jobs.card.signedByOther": "Signed by {name} \u2014 {role} (not the client)",
  "jobs.card.signatureTyped": "typed name",
  "jobs.card.signatureDrawn": "signed on screen",
  // D-Q4 / CR-003 — on the screen the office invoices from, an
  // acknowledgement must never read as an approval.
  "jobs.card.signatureAcknowledgementOnly": "ACKNOWLEDGEMENT OF ASSESSMENT ONLY \u2014 not quote approval",
  "jobs.card.signatureUnsigned": "\u26a0 UNSIGNED \u2014 {reason} (follow up before invoicing)",
  "jobs.card.materialsHeading": "Call-out & materials",
  "jobs.card.noMaterials": "Nothing captured yet.",
  "jobs.card.lineItem": "Item",
  "jobs.card.lineQty": "Qty",
  "jobs.card.linePrice": "Price",
  "jobs.card.awaitingPricing": "🏷 awaiting office pricing",
  // WP-30 (V6) — O-05 evidence section. The placeholder string this replaces
  // ("Field media arrives with the media work package") was still on screen
  // long after the upload pipeline shipped.
  "jobs.card.photosHeading": "Photos & video",
  "jobs.card.noMedia": "No photos or video from site yet.",
  "jobs.card.mediaLoading": "Loading media…",
  "jobs.card.mediaListFailed": "Media could not be loaded. Refresh to try again.",
  "jobs.card.mediaUnavailable": "This file could not be opened.",
  "jobs.card.mediaVerifying": "⌛ Uploaded — being checked",
  "jobs.card.mediaRejected": "⚠ Rejected on upload — {reason}",
  "jobs.card.mediaNoReason": "no reason recorded",
  "jobs.card.mediaTag.BEFORE": "Before",
  "jobs.card.mediaTag.AFTER": "After",
  "jobs.card.mediaAlt": "{tag} photo from site, {when}",
  "jobs.card.invoiceHeading": "Invoice",
  "jobs.card.notInvoiced": "Not yet invoiced (invoices are created in QuickBooks, never here).",
  "jobs.card.invoiceSuperseded": "superseded",
  "jobs.card.invoiceLine": "{number} · {date}",
  "jobs.card.activityHeading": "Activity & audit trail",
  "jobs.card.stageChanged": "Stage {from} → {to} ({by})",
  "jobs.card.jobCreatedEntry": "Job created ({by})",
  "jobs.card.holdRequestEntry": "{by} requested On Hold — “{reason}” · {status}",

  // WP-14 — O-06 Master Calendar
  "calendar.day": "Day",
  "calendar.foremanFilter": "Foreman",
  "calendar.allForemen": "All foremen",
  "calendar.scheduleLink": "Schedule a job",
  "calendar.loading": "Loading the calendar…",
  "calendar.noForemen": "No foremen on the team yet.",
  "calendar.freeDay": "No bookings.",
  "calendar.reassign": "Reassign job {job}",
  "calendar.reassignShort": "Reassign",

  // WP-14 — O-07 Schedule / Assign
  "schedule.pickJob": "Open a job from the calendar or job card to schedule it.",
  "schedule.goToJobs": "Go to jobs",
  "schedule.assigning": "Scheduling job {job}",
  "schedule.reassigning": "Reassigning job {job} (the previous booking is kept in history)",
  "schedule.check": "Check for clashes",
  "schedule.checking": "Checking…",
  // UX-4c (UX2-O07-4, decision-lane row 101): a failed clash check is said, not swallowed.
  "schedule.checkFailed": "Couldn't check this slot for clashes. Try again — booking re-checks it either way.",
  "schedule.book": "Book",
  "schedule.reassign": "Reassign",
  "schedule.noClash": "No clash — the slot is clear.",
  "schedule.overrideLabel": "Book anyway (override the travel-time clash — this is logged)",
  "schedule.form.foreman": "Foreman",
  "schedule.form.chooseForeman": "Choose a foreman…",
  "schedule.form.start": "Slot start",
  "schedule.form.end": "Slot end",
  "schedule.form.reason": "Reason for reassignment",
  "schedule.form.foremanRequired": "Choose a foreman.",
  "schedule.form.slotRequired": "Pick a start and end time.",
  "schedule.form.slotOrder": "The end must be after the start.",
  "schedule.form.reasonRequired": "A reason is required to reassign a scheduled job.",
  "schedule.clash.heading": "This slot clashes (travel allowance {minutes} min):",
  "schedule.clash.overlap": "Overlaps job {job} ({start}–{end})",
  "schedule.clash.travelGap": "Too little travel time before/after job {job} ({start}–{end})",
  "schedule.clash.suggestions": "Nearest open slots:",
  "schedule.confirmStatus.PENDING": "Confirmation pending",
  "schedule.confirmStatus.SENT": "Confirmation sent",
  "schedule.confirmStatus.FAILED": "Confirmation failed",

  // WP-14 — O-08 Booking Confirmation (send-status surface)
  "confirmation.pickJob": "Open a scheduled job to see its booking confirmation.",
  "confirmation.goToCalendar": "Go to the calendar",
  "confirmation.loading": "Loading the confirmation…",
  "confirmation.statusLabel": "Send status",
  // WP-T-2 (UX v1.6 O-08): the §10.9 title of the template card.
  "confirmation.template": "What the client receives",
  "confirmation.sentAt": "Sent {at}",
  "confirmation.systemSent": "Booking confirmations are sent automatically — there is nothing to send by hand.",
  "confirmation.resend": "Resend",
  "confirmation.resending": "Resending…",
  "confirmation.resendFailed": "Couldn't resend the confirmation. Try again.",
  // UX-4b (UX2-O08-2): the polite announcement of a send-status change.
  "confirmation.statusChanged": "Send status changed: {status}",
  "confirmation.failedHint": "The confirmation didn't send. Check the client's email on the job, then resend.",
  "confirmation.date": "Date",
  "confirmation.arrivalWindow": "Arrival window",

  // WP-26 — CR-004 delay flag (O-05 banner + notification bell, US 4.6)
  "jobs.card.delayBanner": "⏱ Running late — {reason} (reported {at} by {by})",
  "jobs.card.delayEntry": "⏱ Running late — {reason} ({by})",
  // WP-T-2 (UX v1.6 §10.9) — completeness read-outs in O-05 card title rows.
  "jobs.card.completeness.verified": "{count} ✓",
  "jobs.card.completeness.pending": "{count} ⌛",
  "jobs.card.completeness.priced": "prices ✓",
  "jobs.card.completeness.signed": "signed ✓",
  "jobs.card.completeness.notYet": "not yet",
  "delay.reason.TRAFFIC": "Traffic",
  "delay.reason.PREVIOUS_JOB_OVERRAN": "Previous job overran",
  "delay.reason.MATERIALS_TRIP": "Materials trip",
  "delay.reason.OTHER": "Other",
  "bell.label": "Notifications",
  "bell.title": "Running-late reports",
  "bell.empty": "No delays reported.",
  "bell.item": "Job {jobNumber} — {reason}",
  "bell.markAllRead": "Mark all as seen",
  "bell.unreadCount": "{count} new delay report(s)",

  // --- WP-15 — O-11 Quotes (US 5.3) ------------------------------------------
  "quotes.filterLabel": "Status", // UX-4e (UX2-O11-4): the O-11a wireframe's visible `Status` label
  "quotes.filterAll": "All quotes",
  "quotes.new": "New quote",
  "quotes.loading": "Loading quotes…",
  "quotes.empty": "No quotes yet.",
  "quotes.chaseDue": "Chase due",
  "quotes.board.none": "none",
  "quotes.col.number": "Quote",
  "quotes.col.client": "Client",
  "quotes.col.status": "Status",
  "quotes.col.total": "Total",
  "quotes.col.expires": "Expires",
  "quotes.status.DRAFT": "Draft",
  "quotes.status.ISSUED": "Issued",
  "quotes.status.APPROVED": "Approved",
  "quotes.status.REJECTED": "Rejected",
  "quotes.status.EXPIRED": "Expired",
  "quotes.form.clientLabel": "Client",
  "quotes.form.clientSearch": "Search clients by name or phone…",
  "quotes.form.cancel": "Cancel",
  "quotes.form.itemRequired": "Choose a catalogue item",
  "quotes.form.reasonRequired": "A reason is required",
  "quotes.detail.back": "Back to quotes",
  "quotes.detail.issued": "Issued",
  "quotes.detail.expires": "Valid until",
  "quotes.detail.convertedTo": "Converted to job",
  "quotes.detail.approvalEvidence": "Approval evidence",
  "quotes.detail.lineItems": "Line items",
  "quotes.detail.noLines": "No line items yet — add catalogue-priced items before issuing.",
  "quotes.detail.item": "Item",
  "quotes.detail.qty": "Qty",
  "quotes.detail.unitPrice": "Unit price",
  "quotes.detail.lineTotal": "Line total",
  "quotes.detail.removeLine": "Remove",
  // UX-4b (UX2-O11-7): the visually-hidden name of the Remove column header.
  "quotes.detail.lineActions": "Actions",
  "quotes.detail.addLine": "Add catalogue item",
  "quotes.detail.addLineButton": "Add line",
  "quotes.detail.pickItem": "Choose an item…",
  "quotes.detail.actions": "Actions",
  "quotes.detail.versions": "Versions",
  "quotes.detail.history": "Status history",
  "quotes.detail.system": "system",
  "quotes.action.issue": "Issue quote (emails PDF)",
  "quotes.action.approve": "Record approval",
  "quotes.action.evidence": "Approval evidence (optional)",
  "quotes.action.evidencePlaceholder": "e.g. Client accepted by phone",
  "quotes.action.reject": "Reject…",
  "quotes.action.rejectReason": "Reason for rejection",
  "quotes.action.rejectConfirm": "Reject quote",
  "quotes.action.revise": "New version",
  "quotes.action.convert": "Convert to job",
  "quotes.settings.toggle": "Quote settings",
  "quotes.settings.title": "Quote validity & follow-up",
  "quotes.settings.hint": "Editable by owner and office manager (D-Q2).",
  "quotes.settings.validityDays": "Validity (days)",
  "quotes.settings.chaseAfterDays": "Chase after (days)",
  "quotes.settings.save": "Save settings",
  "quotes.settings.saving": "Saving…",
  "quotes.settings.saved": "Saved.",

  // --- WP-16 — O-09 Ready-for-Invoicing worklist + O-10 link-back (US 5.1/5.2) --
  "worklist.heading": "Ready for Invoicing",
  "worklist.contract":
    "A job leaves this list only when invoiced, or cancelled with a reason. Bookkeepers: flag it to the office manager.",
  "worklist.loading": "Loading the worklist…",
  "worklist.empty": "Nothing waiting to be invoiced. 🎉",
  "worklist.count": "{count} waiting",
  "worklist.col.job": "Job #",
  "worklist.col.client": "Client",
  "worklist.col.completed": "Completed",
  "worklist.col.waiting": "Waiting",
  "worklist.sorted": "sorted: longest waiting first",
  "worklist.col.evidence": "Evidence",
  "worklist.col.action": "Action",
  "worklist.waitingDays": "{days} days waiting",
  "worklist.waitingToday": "new",
  "worklist.evidence.complete": "✓ complete",
  "worklist.evidence.noPhotos": "⚠ no photos",
  "worklist.flagged": "⚑ flagged: {reason}",
  "worklist.linkInvoice": "Link invoice #",
  "worklist.flag": "⚑ Flag for office manager",

  "linkback.title": "Link QuickBooks invoice — job {job}",
  "linkback.clientOnJob": "Client on job: {client}",
  "linkback.step1": "1. Create the invoice in QuickBooks Online (adjust line items there as needed).",
  "linkback.openQbo": "↗ Open QuickBooks",
  "linkback.step2": "2. Enter the invoice number here:",
  "linkback.numberLabel": "QB invoice #",
  "linkback.dateLabel": "Invoice date",
  "linkback.customerRefLabel": "Customer as shown on the invoice (optional — checked against the client)",
  "linkback.numberRequired": "Enter the QuickBooks invoice number.",
  "linkback.noInvoiceInApp": "Invoices are created in QuickBooks, never in this app (BR-020).",
  "linkback.mismatchWarning":
    "⚠ Check: the invoice reference reads “{invoiceRef}” — the job's client is “{jobClient}”. Link anyway?",
  "linkback.fixNumber": "✕ Fix number", // UX-4e (UX2-O10-4): the drawn ✕
  "linkback.confirmLink": "Confirm link (logged)",
  "linkback.submit": "Link invoice",
  "linkback.submitting": "Linking…",
  "linkback.cancel": "Cancel",
  "linkback.history": "Reference history for this job:",
  "linkback.current": "current",
  "linkback.superseded": "superseded",

  "flag.title": "Flag job {job} for the office manager",
  "flag.reasonLabel": "Reason (required — raised to the office manager)",
  "flag.reasonRequired": "A reason is required.",
  "flag.submit": "Flag for office manager",
  "flag.submitting": "Flagging…",
  "flag.cancel": "Cancel",

  // --- WP-17 — O-02 Dashboard (US 6.2) ---------------------------------------
  "dashboard.loading": "Loading dashboard…",
  "dashboard.error": "Could not load the dashboard.",
  "dashboard.periodLabel": "Period",
  "dashboard.period.week": "Last 7 days",
  "dashboard.period.month": "Last month",
  "dashboard.period.quarter": "Last quarter",
  "dashboard.period.all": "All time",
  "dashboard.tiles.title": "Jobs by stage",
  "dashboard.empty": "No jobs in this period yet.",
  "dashboard.emptyQuotes": "No quotes in this period yet.",
  "dashboard.tile.NEW": "New",
  "dashboard.tile.SCHEDULED": "Scheduled",
  "dashboard.tile.ON_SITE": "On site",
  "dashboard.tile.IN_PROGRESS": "In progress",
  "dashboard.tile.ON_HOLD": "On hold",
  "dashboard.tile.COMPLETED": "Completed",
  "dashboard.tile.READY_FOR_INVOICING": "Ready for invoicing",
  "dashboard.tile.INVOICED": "Invoiced",
  "dashboard.tile.CANCELLED": "Cancelled",
  "dashboard.quotes.title": "Quote → invoice conversion",
  "dashboard.quotes.issued": "Issued",
  "dashboard.quotes.approved": "Approved",
  "dashboard.quotes.converted": "Converted",
  "dashboard.summary.title": "This period",
  "dashboard.summary.completed": "Jobs completed",
  "dashboard.summary.invoiced": "Invoices linked",
  "dashboard.attention.title": "Needs attention",
  "dashboard.attention.empty": "Nothing needs attention right now.",
  "dashboard.attention.onHold": "{count} job(s) on hold",
  "dashboard.attention.ready": "{count} job(s) ready for invoicing",
  "dashboard.attention.delay": "Job {jobNumber} running late — {reason}",

  // --- WP-17 — O-13 Foreman history (US 6.1) ---------------------------------
  "foremen.loading": "Loading foremen…",
  "foremen.error": "Could not load foremen.",
  "foremen.empty": "No foremen yet.",
  "foremen.title": "Foremen",
  "foremen.inactive": "(deactivated)",
  "foremen.viewHistory": "View history",
  "foremen.col.foreman": "Foreman",
  "foremen.col.status": "Status",
  "foremen.active": "Active",
  // UX-4a (UX2-O13-1) — the status cell's accessible text for a deactivated foreman.
  "foremen.statusInactive": "Inactive",
  "history.loading": "Loading history…",
  "history.error": "Could not load the history.",
  "history.empty": "No jobs for this foreman in this period.",
  "history.back": "← All foremen",
  "history.title": "History — {email}",
  "history.periodLabel": "Period",
  "history.statusLabel": "Stage",
  "history.statusAll": "All stages",
  "history.col.job": "Job #", // UX-4e (UX2-O13b-1)
  "history.col.client": "Client",
  "history.col.stage": "Stage",
  "history.col.role": "Role",
  "history.col.slot": "Date", // UX-4e (UX2-O13b-1)
  "history.col.onSite": "On site",
  "history.role.ACTIVE": "Current",
  "history.role.SUPERSEDED": "Reassigned away",

  // --- WP-17 — O-15 Org settings (owner-only, MT-F13) ------------------------
  "org.loading": "Loading settings…",
  "org.error": "Could not load organization settings.",
  "org.saved": "Saved.",
  "org.branding.title": "Branding",
  "org.branding.primaryColor": "Primary colour",
  "org.branding.accentColor": "Accent colour",
  "org.branding.pdfFooter": "PDF footer",
  "org.branding.emailDisplay": "Email display name",
  "org.branding.logo": "Logo",
  "org.branding.noLogo": "No logo uploaded.",
  "org.branding.upload": "Upload logo",
  "org.branding.uploading": "Uploading…",
  "org.branding.save": "Save branding",
  "org.branding.saving": "Saving…",
  "org.branding.storageOff": "Logo upload needs object storage (available at go-live).",
  // WP-UX-1 — UX v1.6 §10.1.1 colour-guard notice (verbatim from the spec).
  // WP-T-2 carry-in (d) — §10.1 tenant accent presets (swatch names; ids from @steier/shared TENANT_ACCENT_PRESETS).
  "org.branding.presets": "Accent presets",
  "org.branding.preset.action-blue": "Action blue",
  "org.branding.preset.teal": "Teal",
  "org.branding.adjusted":
    "Adjusted for legibility: your colour is used for fills; a darker shade is used for text and buttons.",
  "org.smtp.title": "Email sender identity",
  "org.smtp.fromAddress": "From address",
  "org.smtp.fromDisplay": "From display name",
  "org.smtp.replyTo": "Reply-to (optional)",
  "org.smtp.mode": "Mode",
  "org.smtp.save": "Save sender identity",
  "org.smtp.saving": "Saving…",
  "org.qbo.title": "QuickBooks Online",
  "org.qbo.connected": "Connected (realm {realm}).",
  "org.qbo.disconnected": "Not connected.",
  "org.qbo.connect": "Connect QuickBooks",
  "org.qbo.disconnect": "Disconnect",
  "org.qbo.notConfigured": "QuickBooks connect becomes available at go-live (H-4).",
  "org.usage.title": "Storage usage",

  // --- WP-17 — notification bell (persistent GET /notifications store) --------
  "notif.title": "Notifications",
  "notif.empty": "You're all caught up.",
  "notif.markAllRead": "Mark all as read",
  // UX-4a (UX2-NOTIF-5) — the trigger's name carries the count; the polite
  // status line announces the mark-all-read result.
  "notif.labelUnread": "Notifications, {count} unread",
  "notif.allMarkedRead": "All notifications marked as read.",

  // --- WP-27 — O-14 catalogue admin (US 4.4) ----------------------------------
  "catalogue.title": "Catalogue",
  "catalogue.loading": "Loading catalogue…",
  "catalogue.error": "Could not load the catalogue.",
  // AUDIT-FIX STEIER-P1-12 — a failed read must never read as "nothing here".
  "catalogue.queueError":
    "Could not load the from-the-field queue — items awaiting pricing may be hidden.",
  "catalogue.allItemsError":
    "Could not load the full item list — merge targets and the updated stamp may be incomplete.",
  "catalogue.empty": "No items in this section yet.",
  "catalogue.addItem": "+ Add item",
  "catalogue.tab.callouts": "Call-outs",
  "catalogue.tab.travel": "Travel",
  "catalogue.tab.materials": "Materials",
  "catalogue.col.item": "Item",
  "catalogue.col.unit": "Unit",
  "catalogue.col.price": "Price",
  "catalogue.col.actions": "Actions",
  "catalogue.pendingBadge": "🏷 awaiting pricing",
  "catalogue.priceAction": "Price…",
  "catalogue.editAction": "Edit",
  "catalogue.retireAction": "Retire",
  "catalogue.retireConfirm": "Confirm retire",
  "catalogue.updated": "Catalogue updated {date}",
  "catalogue.queue.title": "From the field — needs pricing ({count})",
  "catalogue.queue.attribution": "{foreman}, job {jobNumber}",
  "catalogue.queue.unassigned": "unassigned",
  "catalogue.queue.priceAndAdd": "Price & add",
  "catalogue.queue.mergeWith": "Merge with…",
  "catalogue.queue.mergeTargetLabel": "Merge into",
  "catalogue.queue.mergeConfirm": "Merge",
  "catalogue.form.addTitle": "Add catalogue item",
  "catalogue.form.priceTitle": "Price item",
  "catalogue.form.editTitle": "Edit item",
  "catalogue.form.priceAndAddTitle": "Price & add to catalogue",
  "catalogue.form.typeLabel": "Section",
  "catalogue.form.nameLabel": "Name",
  "catalogue.form.priceLabel": "Price (R)",
  "catalogue.form.unitLabel": "Unit",
  "catalogue.form.unitPlaceholder": "each / metre",
  "catalogue.form.categoryLabel": "Category",
  "catalogue.form.itemCodeLabel": "Item code",
  "catalogue.form.priceBasisLabel": "Pricing basis",
  "catalogue.form.save": "Save",
  "catalogue.form.cancel": "Cancel",
  "catalogue.form.nameRequired": "An item name is required.",
  "catalogue.form.priceInvalid": "Enter a price like 95.00.",
  // --- WP-32 (residual AC gaps) ---
  "time.hoursMinutes": "{h} h {m} min",
  "time.minutes": "{m} min",
  "jobs.time.openCheckIn": "⏱ Checked in at {at} and not checked out yet.",
  "jobs.time.refusedCheckIn": "⚠ A check-in by {by} at {at} was refused (job booked for a different day). Record the real time if the work was done.",
  "jobs.time.recordRefused": "Record this time…",
  "jobs.time.onSiteTotal": "On site: {duration} (materials trips excluded)",
  "jobs.time.addedByOffice": "✎ ADDED BY OFFICE",
  "jobs.time.corrected": "✎ CORRECTED",
  "jobs.time.original": "(phone recorded {at})",
  "jobs.time.correct": "Correct…",
  "jobs.time.correctionEntry": "Set to {to} by {by} on {when} — {reason}",
  "jobs.time.correctionsLog": "Corrections log ({count})",
  "jobs.time.addCheckOut": "Add missing check-out…",
  "jobs.time.addCheckIn": "Add missing check-in…",
  "jobs.time.summaryLink": "Client time summary",
  "jobs.time.dialogEdit": "Correct: {what}",
  "jobs.time.whenLabel": "Correct time",
  "jobs.time.saveCorrection": "Save correction",
  "jobs.summary.loading": "Loading the time summary…",
  "jobs.summary.back": "← Job {job}",
  "jobs.summary.title": "Time on site — job {job}",
  "jobs.summary.date": "Date",
  "jobs.summary.arrived": "Arrived",
  "jobs.summary.left": "Left",
  "jobs.summary.stillOnSite": "Still on site",
  "jobs.summary.total": "Total time on site",
  "jobs.summary.none": "No time on site has been recorded for this job yet.",
  "jobs.summary.tripsHeading": "Trips to fetch materials (travel, not time on site)",
  "jobs.summary.trip": "{left}–{returned} ({duration})",
  "jobs.summary.tripOpen": "Left at {left}, not yet back",
  "jobs.summary.correctedNote": "* Corrected by the office; the original record is kept on the job card.",
  "jobs.summary.print": "Print / save as PDF",
  "jobs.summary.copy": "Copy text for the client",
  "jobs.summary.copied": "Copied",
  "jobs.summary.factsHeading": "Time on site",
  "jobs.summary.textHeading": "Text for the client",
  "booking.state.PROVISIONAL": "Provisional",
  "booking.state.CONFIRMED": "Confirmed",
  "booking.confirmAction": "Confirm booking",
  "booking.provisionalHint": "This booking is provisional — the client has not been emailed. Confirm it once the slot is agreed; the confirmation email goes out then.",
  "booking.provisionalLabel": "Book as provisional (hold the slot; email the client when confirmed)",
  "calendar.actual": "Actual {in}–{out}",
  "calendar.onSiteSince": "On site since {in}",
  "calendar.finished": "✓ Finished",
  "calendar.emailLabel": "Email:",
  "calendar.travelGap": "░ {minutes} min travel (allowance {allowance} min)",
  "calendar.noTravelGap": "⚠ NO TRAVEL GAP — {minutes} min between jobs (allowance {allowance} min)",
  // AF-4 (row 63b): an override booking can OVERLAP its neighbour; a negative
  // gap is an overlap, never "-115 min between jobs".
  "calendar.overlap": "⚠ OVERLAP — bookings overlap by {minutes} min (allowance {allowance} min)",
  "calendar.viewLabel": "Calendar view",
  "calendar.viewDay": "Day",
  "calendar.viewWeek": "Week",
  "calendar.previous": "Previous",
  "calendar.next": "Next",
  "calendar.legend": "■ confirmed  ▒ provisional  ░ travel gap ({minutes} min allowance)  ⚠ no travel gap  * time corrected by the office",
  "calendar.foremanColumn": "Foreman",
  "dashboard.tiles.hint": "Jobs created in the period, by their stage now.",
  "dashboard.tileView": "view →",
  "dashboard.summary.delays": "Jobs reported running late",
  "dashboard.quotes.invoiced": "Invoiced",
  "dashboard.quotes.conversion": "Quote-to-invoice conversion: {rate}% ({invoiced} of {issued} quotes issued in the period)",
  "dashboard.quotes.conversionNone": "Quote-to-invoice conversion: no quotes issued in this period.",
  "dashboard.quotes.conversionValue": "{rate}% ({invoiced} of {issued} quotes)",
  "dashboard.attention.hint": "Right now — not limited to the period.",
  "dashboard.attention.forgottenCheckout": "Job {jobNumber}: {by} checked in at {at} and has not checked out",
  "dashboard.drilldown.back": "← Dashboard",
  "dashboard.drilldown.total": "{count} in this list — the same number as on the dashboard.",
  "dashboard.drilldown.job": "Job",
  "dashboard.drilldown.client": "Client",
  "dashboard.drilldown.stage": "Stage",
  "dashboard.drilldown.created": "Created",
  "dashboard.drilldown.quote": "Quote",
  "dashboard.drilldown.status": "Status",
  "dashboard.drilldown.issued": "Issued",
  "dashboard.drilldown.convertedJob": "Converted to job",
  "dashboard.drilldown.invoice": "Invoice",
  "dashboard.metric.stage.NEW": "New jobs",
  "dashboard.metric.stage.SCHEDULED": "Scheduled jobs",
  "dashboard.metric.stage.ON_SITE": "Jobs on site",
  "dashboard.metric.stage.IN_PROGRESS": "Jobs in progress",
  "dashboard.metric.stage.ON_HOLD": "Jobs on hold",
  "dashboard.metric.stage.READY_FOR_INVOICING": "Jobs ready for invoicing",
  "dashboard.metric.stage.INVOICED": "Invoiced jobs",
  "dashboard.metric.completed": "Jobs completed",
  "dashboard.metric.invoiced": "Invoices linked",
  "dashboard.metric.delays": "Jobs reported running late",
  "dashboard.metric.backlog.onHold": "On hold right now",
  "dashboard.metric.backlog.readyForInvoicing": "Ready for invoicing right now",
  "dashboard.metric.forgottenCheckouts": "Forgotten check-outs",
  "dashboard.metric.quotes.issued": "Quotes issued",
  "dashboard.metric.quotes.approved": "Quotes approved",
  "dashboard.metric.quotes.converted": "Quotes converted to jobs",
  "dashboard.metric.quotes.invoiced": "Quotes that reached an invoice",
  "history.fromLabel": "From",
  "history.toLabel": "To",
  "history.clearRange": "Clear dates",
  "history.corrected": "✎ corrected",
  "history.permanentNote":
    "🔒 This history is permanent and cannot be edited. It is retained if the account is deactivated.",
  "platform.usage.title": "Platform — storage usage per tenant",
  "platform.usage.intro": "Dark Star operator view: each tenant's media storage against the included 1 TB.",
  "platform.usage.email": "Platform email",
  "platform.usage.password": "Password",
  "platform.usage.signIn": "Sign in",
  "platform.usage.signInFailed": "Sign-in failed.",
  "platform.usage.loading": "Loading usage…",
  "platform.usage.tenant": "Tenant",
  "platform.usage.status": "Status",
  "platform.usage.usage": "Usage",
  "platform.usage.period": "Metered",
  "platform.usage.flag": "Cap",
  "platform.usage.neverScanned": "not scanned yet",
  "platform.usage.overCap": "Over the cap",
  "platform.usage.approaching": "Approaching the cap",
  "platform.usage.ok": "Within the cap",
  "platform.usage.refresh": "Refresh",

  // ==== UX-4e (office reads, copy and quote-status chips) — one contiguous block ====
  // E2 singular partners — chosen by i18n/plural.ts at a count of exactly 1.
  "worklist.waitingDaysOne": "{days} day waiting", // UX2-O09-3
  "clients.jobCountOne": "{count} job", // UX2-O12-1
  // E5 — O-15 storage (UX2-O15-1, D-C2): the threshold line and the two state banners (text + glyph).
  "org.usage.alertAt": "▲ alert at {percent} % of cap",
  "org.usage.approaching": "▲ Approaching the storage cap — {percent} % or more of the included storage is in use.",
  "org.usage.overCap": "✕ Over the included storage cap — storage beyond it is billed.",
  // E6 — the O-08 letter (UX2-O08-1; office O-08 lines 499–504). Date / Arrival window reuse confirmation.date / .arrivalWindow.
  "confirmation.letter.greeting": "Good day,",
  "confirmation.letter.confirms": "{business} confirms your booking:",
  "confirmation.letter.jobReference": "Job reference",
  "confirmation.letter.signOff": "Regards,",
  // UX2-O11-6 — the O-11b draft-only note (office O-11b; the `[Resend]` half stays F-T2-8).
  "quotes.detail.systemSent": "ℹ On Issue the quote PDF is rendered and emailed to the client automatically — there is nothing to send by hand.",
  // UX2-O09-6 — the O-09 row's visible flag label; the accessible name stays worklist.flag (which starts with it).
  "worklist.flagShort": "⚑ Flag",
  // ==== end UX-4e ====
} as const;

export type CatalogueKey = keyof typeof en;
